import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

import TabPanel from '../../components/TabPanel';
import Button from '../Button'

function InsuranceEditModal(props) {
  const {
    insurance,
    open,
    save,
    onClose,
    classes: {
      modal,
      modalContent,
      actions,
      input,
    },
  } = props;

  const [name, setName] = useState('')
  const [shortName, setShortName] = useState('')
  const [validationErrors, setValidationErrors] = useState({})

  useEffect(() => {
    setName(insurance.name)
    setShortName(insurance.shortName)
  }, [])
  
  const validate = () => {
    let valid = true
    const nextState = {}
    if (!name) {
      nextState.name = 'Required'
      valid = false
    }
    if (!shortName && !insurance.id) {
      nextState.shortName = 'Required'
      valid = false
    }
    setValidationErrors(nextState)
    return valid
  }
  
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: modal }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>{insurance.name || 'New Insurance'}</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="Profile" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <DialogContent>
            <TextField
              fullWidth
              variant="outlined"
              name="name"
              label="Name"
              value={name}
              onChange={event => {
                setName(event.target.value)
                setValidationErrors({ ...validationErrors, name: false })
              }}
              error={validationErrors.name}
              helperText={validationErrors.name}
              className={input}
            />

            <TextField
              fullWidth
              disabled={!!insurance.id}
              variant="outlined"
              name="shortName"
              label="Short Name"
              value={shortName}
              onChange={event => {
                setShortName(event.target.value)
                setValidationErrors({ ...validationErrors, shortName: false })
              }}
              error={validationErrors.shortName}
              helperText={validationErrors.shortName}
              className={input}
            />
          </DialogContent>

          <Grid
            container
            justifyContent="flex-end"
            classes={{ container: actions }}
          >
            <Grid item xs={12} lg={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={() => save({ id: insurance.id, name, shortName })}
                onClickValidation={validate}
              >
                Save Insurance
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}

InsuranceEditModal.propTypes = {
  insurance: PropTypes.object,
  open: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
});

export default withStyles(styles)(InsuranceEditModal);
